import { appStorage } from "./appStorage";
import {
  APP_SETUP_WIZARD_KEY,
  APP_SETUP_STEP_KEY,
  APP_SETUP_SIGNUP_KEY,
  APP_SETUP_STEPS,
} from "../config/appSetupConfig";

export const startAppSetupWizard = () => {
  appStorage.setItem(APP_SETUP_WIZARD_KEY, "1");
  appStorage.setItem(APP_SETUP_STEP_KEY, APP_SETUP_STEPS.SIGNUP);
};

export const finishAppSetupWizard = () => {
  appStorage.removeItem(APP_SETUP_WIZARD_KEY);
  appStorage.removeItem(APP_SETUP_STEP_KEY);
  appStorage.removeItem(APP_SETUP_SIGNUP_KEY);
};

export const isAppSetupWizardActive = () =>
  appStorage.getItem(APP_SETUP_WIZARD_KEY) === "1";

export const getAppSetupStep = () =>
  appStorage.getItem(APP_SETUP_STEP_KEY) || APP_SETUP_STEPS.SIGNUP;

export const setAppSetupStep = (step) => {
  appStorage.setItem(APP_SETUP_STEP_KEY, step);
};

export const saveAppSetupSignupDraft = (draft) => {
  try {
    appStorage.setItem(APP_SETUP_SIGNUP_KEY, JSON.stringify(draft));
  } catch {
    // ignore
  }
};

export const getAppSetupSignupDraft = () => {
  try {
    const raw = appStorage.getItem(APP_SETUP_SIGNUP_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};
